import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { I18nService } from '../../../services';

@Component({
  selector: 'app-contact-us-submit-modal',
  templateUrl: './contact-us-submit-modal.component.html',
  styleUrls: ['./contact-us-submit-modal.component.scss'],
  standalone: false,
})
export class ContactUsSubmitModalComponent {
  private readonly router: Router = inject(Router);
  private readonly i18nService: I18nService = inject(I18nService);

  @Input() showModalSubmit!: boolean;
  @Input() cartItemsLength: any;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  submitOnClick(proceedBtn: boolean): void {
    this.showModalSubmit = false;

    if (proceedBtn) {
      this.router.navigate(['/quote-summary']).then();
    } else {
      this.router.navigate([this.i18nService.getCurrentLocale()]).then();
    }
  }

  closeModalSubmit(): void {
    this.closeModal.emit();
  }
}
